import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocalization } from '@/hooks/use-localization';

type MenuItemProps = {
    title: string;
    children?: React.ReactNode;
    to: string;
    isLast?: boolean;
    setShowMenu: (showMenu: boolean) => void;
};

export const MenuItem = ({ title, children, to, isLast = false, setShowMenu }: MenuItemProps) => {
    const { localize } = useLocalization();
    const [isOpen, setIsOpen] = useState(() => {
        if (typeof window === 'undefined') return false;
        const storedState = window.localStorage.getItem(`menuItem-${title}`);
        return storedState === 'open';
    });

    useEffect(() => {
        if (isOpen) {
            window.localStorage.setItem(`menuItem-${title}`, 'open');
        } else {
            window.localStorage.removeItem(`menuItem-${title}`);
        }
    }, [isOpen]);

    return (
        <li className={clsx({ 'r-border-b': !isLast }, `${isOpen && children ? 'r-pb-4' : ''}`)}>
            <div className="r-mb-3 r-flex r-justify-between">
                <Link to={to} className="r-text-xl r-font-medium" onClick={() => setShowMenu(false)}>
                    {title}
                </Link>
                {children && (
                    <button
                        onClick={() => children && setIsOpen(!isOpen)}
                        aria-label={isOpen ? localize('collapse-submenu') : localize('expand-submenu')}
                        aria-expanded={isOpen}
                    >
                        <img src="/assets/icons/close.svg" className={`r-h-7 r-w-7 r-transition-all ${isOpen ? '' : 'r-rotate-45'}`} alt="" />
                    </button>
                )}
            </div>
            {isOpen && children && <ul className="r-ml-5 r-space-y-6 r-pt-2">{children}</ul>}
        </li>
    );
};
